import BaseComparison from './baseComparison';

class LessThan extends BaseComparison {
    constructor(registry) {
        super("lessThan", registry);
    }

    compareValues(value1, value2) {
        return value1 < value2;
    }
}

export default LessThan;
